import React, { useState } from 'react';
import { EyeIcon, EyeOffIcon } from 'lucide-react';

const PasswordInput = ({ 
  value, 
  onChange, 
  onBlur,
  placeholder = "Şifre", 
  className = "",
  disabled = false,
  id,
  name,
  required = false,
  ...props 
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="relative">
      <input
        type={showPassword ? "text" : "password"}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        className={`w-full pr-10 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${className}`}
        disabled={disabled}
        id={id}
        name={name}
        required={required}
        {...props}
      />
      <button
        type="button"
        className="absolute inset-y-0 right-0 pr-3 flex items-center"
        onClick={togglePasswordVisibility}
        disabled={disabled}
      >
        {showPassword ? (
          <EyeOffIcon className="h-4 w-4 text-gray-400 hover:text-gray-600" />
        ) : (
          <EyeIcon className="h-4 w-4 text-gray-400 hover:text-gray-600" />
        )}
      </button>
    </div>
  );
};

export default PasswordInput;